(function(){"use strict";
/* NKOSI G6 2026-09-07 — asset de theme charge sur toutes les pages.
   1) frise des paliers de livraison offerte dans le tiroir Moon Bundles
   2) traduction du tiroir, du popup d'ajout et du selecteur de cadeau en EN/DE/IT
   3) glissement tactile sur le carrousel "Souvent commande avec"
   La fermeture du tiroir sur /cart reste dans le customJs de l'application.
   Reversion : supprimer assets/nkosi-moon-cart.js et sa balise script dans layout/theme.liquid. */
var L=((window.Shopify&&Shopify.locale)||'fr').slice(0,2).toLowerCase();
if(['fr','en','de','it'].indexOf(L)<0)L='fr';

/* ---------- 2. Frise des paliers de livraison offerte (France metropolitaine) ---------- */
var RELAIS=3900, DOMICILE=6900, MINIMUM=3900; /* MINIMUM : commande minimum 39 EUR (Checkout Blocks), 2026-09-16 */ /* centimes, aligne sur les tarifs Shopify reels */
var FR_T={
 fr:{l1:'relais',l2:'domicile',sub:'France métropolitaine',
     m0:function(a){return 'Encore '+a+' et votre colis peut partir';},
     m1:function(a){return 'Point relais offert. Encore '+a+' pour le domicile offert';},
     m2:'Livraison offerte, en point relais comme à domicile'},
 en:{l1:'pickup',l2:'home',sub:'Mainland France',
     m0:function(a){return 'Just '+a+' more and your parcel can leave';},
     m1:function(a){return 'Free pickup point delivery unlocked. Only '+a+' more for free home delivery';},
     m2:'Free delivery, to a pickup point and to your door'},
 de:{l1:'Shop',l2:'Haus',sub:'Frankreich (Festland)',
     m0:function(a){return 'Noch '+a+', dann kann Ihr Paket losgehen';},
     m1:function(a){return 'Paketshop-Lieferung gratis. Nur noch '+a+' bis zur kostenlosen Lieferung nach Hause';},
     m2:'Versand kostenlos, an den Paketshop und nach Hause'},
 it:{l1:'ritiro',l2:'domicilio',sub:'Francia metropolitana',
     m0:function(a){return 'Ancora '+a+' e il vostro pacco può partire';},
     m1:function(a){return 'Consegna in punto di ritiro gratuita. Ancora '+a+' per la consegna a domicilio gratuita';},
     m2:'Consegna gratuita, in punto di ritiro e a domicilio'}
};
/* vague 1 des maquettes (F3, 28/09/2026) : sur la fiche, la frise dit aussi les cadeaux (39 et 59 €), la barre des cadeaux
   de Moon Bundles n'y est plus. Mêmes textes que snippets/nkosi-mc-frise.liquid (locales nkosi_mc.v1.frise_c). */
var FR_TC={
 fr:{l1:'relais',l2:'domicile',sub:'Un cadeau à chaque palier · livraison en France métropolitaine',
     m0:function(a){return 'Encore '+a+' et votre colis peut partir, avec le relais offert et un premier cadeau.';},
     m1:function(a){return 'Relais offert et premier cadeau débloqué. Encore '+a+' pour le domicile offert et un deuxième cadeau.';},
     m2:'Livraison offerte en relais comme à domicile, et vos deux cadeaux sont débloqués.'},
 en:{l1:'pickup',l2:'home',sub:'A gift at each step · delivery in mainland France',
     m0:function(a){return 'Just '+a+' more and your parcel can leave, with free pickup delivery and a first gift.';},
     m1:function(a){return 'Free pickup delivery and first gift unlocked. Only '+a+' more for free home delivery and a second gift.';},
     m2:'Free delivery to a pickup point or to your door, and both gifts unlocked.'},
 de:{l1:'Shop',l2:'Haus',sub:'Ein Geschenk pro Stufe · Lieferung in Frankreich (Festland)',
     m0:function(a){return 'Noch '+a+', dann kann Ihr Paket losgehen, mit kostenloser Lieferung an den Paketshop und einem ersten Geschenk.';},
     m1:function(a){return 'Paketshop-Lieferung gratis und erstes Geschenk freigeschaltet. Nur noch '+a+' bis zur kostenlosen Lieferung nach Hause und einem zweiten Geschenk.';},
     m2:'Versand kostenlos, an den Paketshop und nach Hause, und beide Geschenke freigeschaltet.'},
 it:{l1:'ritiro',l2:'domicilio',sub:'Un omaggio a ogni soglia · consegna in Francia metropolitana',
     m0:function(a){return 'Ancora '+a+' e il vostro pacco può partire, con il ritiro gratuito e un primo omaggio.';},
     m1:function(a){return 'Ritiro gratuito e primo omaggio sbloccati. Ancora '+a+' per la consegna a domicilio gratuita e un secondo omaggio.';},
     m2:'Consegna gratuita, in punto di ritiro e a domicilio, e i due omaggi sbloccati.'}
};
function euro(c){try{return new Intl.NumberFormat(L==='fr'?'fr-FR':L,{style:'currency',currency:'EUR',minimumFractionDigits:(c%100===0?0:2)}).format(c/100);}catch(e){return (c/100).toFixed(2).replace('.',',')+' €';}}
function paintFrise(total){
  var roots=document.querySelectorAll('[data-nk-frise]');
  for(var k=0;k<roots.length;k++)paintOne(roots[k],total);
}
/* 2026-09-18 : écritures idempotentes. Réécrire un texte identique crée quand même une mutation
   childList, que l'observateur du bas renvoyait à tick() : boucle sans fin (/cart.js toutes les 265 ms). */
function setText(el,v){if(el&&el.textContent!==v)el.textContent=v;}
function setAttr(el,n,on,v){if(!el)return;if(on){if(el.getAttribute(n)!==(v||''))el.setAttribute(n,v||'');}else if(el.hasAttribute(n))el.removeAttribute(n);}
function paintOne(root,total){
  if(!root)return;
  var t=(root.hasAttribute('data-nk-frise-cadeaux')&&FR_TC[L])||FR_T[L];
  var pct=Math.max(0,Math.min(1,total/DOMICILE))*100;
  var fill=root.querySelector('[data-nk-frise-fill]'),w=pct.toFixed(1)+'%';if(fill&&fill.style.width!==w)fill.style.width=w;
  var d1=root.querySelector('[data-nk-frise-dot="1"]'),d2=root.querySelector('[data-nk-frise-dot="2"]');
  if(d1)d1.classList.toggle('is-on',total>=RELAIS);
  if(d2)d2.classList.toggle('is-on',total>=DOMICILE);
  setText(root.querySelector('[data-nk-frise-msg]'), total>=DOMICILE ? t.m2 : (total>=RELAIS ? t.m1(euro(DOMICILE-total)) : t.m0(euro(RELAIS-total))));
  setText(root.querySelector('[data-nk-frise-l1]'),euro(RELAIS)+' '+t.l1);
  setText(root.querySelector('[data-nk-frise-l2]'),euro(DOMICILE)+' '+t.l2);
  setText(root.querySelector('[data-nk-frise-sub]'),t.sub);
  /* vague 1 des maquettes (Antonio, 28/09 0 h 55) : dans le tiroir, l'estimation de livraison à droite de « France
     métropolitaine », à la ligne si la place manque (flottant, nkosi-marche-collage.css section V1) */
  /* 28/09/2026 2 h (Antonio) : petit bandeau en tête de la frise du tiroir, commande minimum du site (MINIMUM) */
  if(root.closest&&root.closest('#moonbundle-cart-drawer')){var bd=root.querySelector('[data-nk-min-bandeau]');
    if(!bd){bd=document.createElement('div');bd.setAttribute('data-nk-min-bandeau','');bd.className='nk-frise__min';root.insertBefore(bd,root.firstChild);}
    setText(bd,MIN_BANDEAU[L](euro(MINIMUM)));}
  if(root.closest&&root.closest('#moonbundle-cart-drawer')){var sb=root.querySelector('[data-nk-frise-sub]');if(sb){
    var et=root.querySelector('[data-nk-v1-eta]');
    if(!et){et=document.createElement('span');et.setAttribute('data-nk-v1-eta','');et.className='nk-v1-eta';sb.parentNode.insertBefore(et,sb.nextSibling);}
    try{setText(et,nkEtaCourt());}catch(e){}}}
  root.classList.toggle('is-complete',total>=DOMICILE);
  setAttr(root,'hidden',false);
}
var lastTotal=null,pending=false;
function refreshFrise(force){
  if(!document.querySelector('[data-nk-frise]')&&!document.querySelector(BUY_SEL))return;
  /* 2026-09-18 : total connu et aucun événement panier : repeindre sans refaire d'appel /cart.js */
  if(lastTotal!==null&&!force){paintFrise(lastTotal);return;}
  if(pending)return;pending=true;
  fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart.js',{headers:{Accept:'application/json'}})
   .then(function(r){return r.json();})
   .then(function(c){lastTotal=c.total_price;paintFrise(lastTotal);minGuard();buyNowGuard();})
   .catch(function(){})
   .then(function(){pending=false;});
}

/* ---------- 3. Traduction du tiroir, du popup d'ajout et du selecteur de cadeau ---------- */
var DICT={
 'Votre panier':{en:'Your cart',de:'Ihr Warenkorb',it:'Il tuo carrello'},
 'Sous-total':{en:'Subtotal',de:'Zwischensumme',it:'Subtotale'},
 'Passer commande':{en:'Checkout',de:'Zur Kasse',it:'Vai alla cassa'},
 'Code de reduction':{en:'Discount code',de:'Rabattcode',it:'Codice sconto'},
 'Code de réduction':{en:'Discount code',de:'Rabattcode',it:'Codice sconto'},
 'Appliquer':{en:'Apply',de:'Anwenden',it:'Applica'},
 "Ce code n'est pas valable.":{en:'This code is not valid.',de:'Dieser Code ist ungültig.',it:'Questo codice non è valido.'},
 'Souvent commandé avec':{en:'Frequently bought together',de:'Häufig zusammen gekauft',it:'Spesso acquistati insieme'},
 'Ajouter':{en:'Add',de:'Hinzufügen',it:'Aggiungi'},
 'Offert':{en:'Free',de:'Gratis',it:'Omaggio'},
 'Épuisé':{en:'Sold out',de:'Ausverkauft',it:'Esaurito'},
 'Remise':{en:'Discount',de:'Rabatt',it:'Sconto'},
 "L'ajout au panier n'a pas abouti. Merci de réessayer.":{en:'The item could not be added to your cart. Please try again.',de:'Der Artikel konnte nicht hinzugefügt werden. Bitte erneut versuchen.',it:'Impossibile aggiungere al carrello. Riprova.'},
 'Produit ajouté à votre panier.':{en:'Item added to your cart.',de:'Artikel wurde hinzugefügt.',it:'Prodotto aggiunto al carrello.'},
 'Votre panier est vide. Découvrez nos épices, farines et boissons d’Afrique et des Caraïbes.':{en:'Your cart is empty. Explore our spices, flours and drinks from Africa and the Caribbean.',de:'Ihr Warenkorb ist leer. Entdecken Sie unsere Gewürze, Mehle und Getränke aus Afrika und der Karibik.',it:'Il tuo carrello è vuoto. Scopri le nostre spezie, farine e bevande africane e caraibiche.'},
 'Ajouté à votre panier':{en:'Added to your cart',de:'Zum Warenkorb hinzugefügt',it:'Aggiunto al carrello'},
 'Continuer mes achats':{en:'Continue shopping',de:'Weiter einkaufen',it:'Continua lo shopping'},
 'Voir mon panier':{en:'View my cart',de:'Warenkorb ansehen',it:'Vedi il carrello'},
 'Choisissez votre cadeau offert':{en:'Choose your free gift',de:'Wählen Sie Ihr Geschenk',it:'Scegli il tuo omaggio'},
 'Choisissez votre deuxième cadeau':{en:'Choose your second gift',de:'Wählen Sie Ihr zweites Geschenk',it:'Scegli il tuo secondo omaggio'},
 'Choisissez votre troisième cadeau':{en:'Choose your third gift',de:'Wählen Sie Ihr drittes Geschenk',it:'Scegli il tuo terzo omaggio'},
 'Rechercher un produit':{en:'Search for a product',de:'Produkt suchen',it:'Cerca un prodotto'},
 'Aucun cadeau disponible pour le moment':{en:'No gift available at the moment',de:'Derzeit ist kein Geschenk verfügbar',it:'Nessun omaggio disponibile al momento'},
 'Ajouter mon cadeau':{en:'Add my gift',de:'Geschenk hinzufügen',it:'Aggiungi il mio omaggio'},
 'Choisir le format':{en:'Choose the size',de:'Größe wählen',it:'Scegli il formato'},
 'Choisir':{en:'Choose',de:'Wählen',it:'Scegli'},
 'Changer de cadeau':{en:'Change gift',de:'Geschenk ändern',it:'Cambia omaggio'},
 'À débloquer':{en:'Locked',de:'Noch gesperrt',it:'Da sbloccare'},
 'Cadeau offert':{en:'Free gift',de:'Geschenk',it:'Omaggio'},
 'Deuxième cadeau':{en:'Second gift',de:'Zweites Geschenk',it:'Secondo omaggio'},
 'Troisième cadeau':{en:'Third gift',de:'Drittes Geschenk',it:'Terzo omaggio'},
 'Produit Gratuit':{en:'Free product',de:'Gratisprodukt',it:'Prodotto gratuito'},
 'Un cadeau offert dès 39 €, un deuxième dès 59 €.':{en:'One free gift from €39, a second from €59.',de:'Ein Geschenk ab 39 €, ein zweites ab 59 €.',it:'Un omaggio da 39 €, un secondo da 59 €.'},
 'Bravo, vos deux cadeaux sont débloqués. Choisissez-les avant de valider votre commande.':{en:'Well done, your two gifts are unlocked. Pick them before you check out.',de:'Super, Ihre zwei Geschenke sind freigeschaltet. Wählen Sie sie vor dem Bezahlen aus.',it:'Bravo, i tuoi due omaggi sono sbloccati. Sceglili prima di completare l’ordine.'},
 'Deuxième cadeau':{en:'Second gift',de:'Zweites Geschenk',it:'Secondo omaggio'},
 'Un cadeau offert dès 59 €, un deuxième dès 79 €, un troisième dès 99 €.':{en:'One free gift from €59, a second from €79, a third from €99.',de:'Ein Geschenk ab 59 €, ein zweites ab 79 €, ein drittes ab 99 €.',it:'Un omaggio da 59 €, un secondo da 79 €, un terzo da 99 €.'},
 'Goût acidulé, pour le jus de bouye et les desserts':{en:'Tangy taste, for bouye juice and desserts',de:'Säuerlicher Geschmack, für Bouye-Saft und Desserts',it:'Gusto acidulo, per il succo di bouye e i dessert'},
 'Mélange prêt à l’emploi pour le maafé et le yassa':{en:'Ready-to-use blend for maafe and yassa',de:'Fertige Mischung für Maafe und Yassa',it:'Miscela pronta per maafe e yassa'},
 'Mélange prêt à l\'emploi pour le maafé et le yassa':{en:'Ready-to-use blend for maafe and yassa',de:'Fertige Mischung für Maafe und Yassa',it:'Miscela pronta per maafe e yassa'},
 'Pâte de piment antillaise, relevée et parfumée':{en:'Caribbean chilli paste, hot and fragrant',de:'Karibische Chilipaste, scharf und aromatisch',it:'Pasta di peperoncino caraibica, piccante e profumata'},
 'La pâte d’arachide de référence pour le maafé':{en:'The benchmark peanut paste for maafe',de:'Die Referenz-Erdnusspaste für Maafe',it:'La pasta di arachidi di riferimento per il maafe'},
 'La pâte d\'arachide de référence pour le maafé':{en:'The benchmark peanut paste for maafe',de:'Die Referenz-Erdnusspaste für Maafe',it:'La pasta di arachidi di riferimento per il maafe'},
 'Bravo, vos trois cadeaux sont débloqués. Choisissez-les avant de valider votre commande.':{en:'Well done, your three gifts are unlocked. Pick them before you check out.',de:'Super, Ihre drei Geschenke sind freigeschaltet. Wählen Sie sie vor dem Bezahlen aus.',it:'Bravo, i tuoi tre omaggi sono sbloccati. Scegli prima di completare l’ordine.'}
};
var RX_DES=/^dès\s*([\d., \s]+)€$/;
function tr(s){
  if(!s)return null;
  var k=s.trim();
  var d=DICT[k];
  if(d&&d[L])return s.replace(k,d[L]);
  var m=k.match(RX_DES);
  if(m){var pre={en:'from €',de:'ab ',it:'da '}[L];if(pre)return L==='en'?('from €'+m[1].trim()):(pre+m[1].trim()+' €');}
  if(/^Vous économisez/.test(k)){var p={en:'You save',de:'Sie sparen',it:'Risparmi'}[L];if(p)return s.replace('Vous économisez',p);}
  if(/unités?\)/.test(k)){var u={en:'units',de:'Stück',it:'unità'}[L],u1={en:'unit',de:'Stück',it:'unità'}[L];if(u)return s.replace(/unités/g,u).replace(/unité(?![s])/g,u1);}
  return null;
}
/* vague 1 des maquettes (Antonio, 28/09 : « pas de mot anglais sur le site français ») : pastilles de remise du tiroir
   (« €2,40 OFF ») et montants au format de Moon Bundles (« €45,52 ») réécrits dans la langue de la page, français
   compris : « 2,40 € déduits », « 45,52 € » ; en anglais, « €2.40 off » et montants inchangés. Écritures idempotentes. */
var OFF_T={fr:' déduits',en:' off',de:' Rabatt',it:' di sconto'}, OFF_P={fr:' de réduction',en:' off',de:' Rabatt',it:' di sconto'};
var RX_EUR=/^(\s*)(-?)\s?€\s?(\d{1,3}(?:[\s\u00a0\u202f.]\d{3})*(?:[.,]\d{1,2})?)(\s*)$/;
var RX_OFF=/^(\s*)(?:€\s?(\d[\d\s\u00a0.,]*?)|(\d[\d\s\u00a0.,]*?)\s?€)\s*OFF(\s*)$/i;
var RX_PCT=/^(\s*)-?(\d+(?:[.,]\d+)?)\s?%\s*OFF(\s*)$/i, RX_OFF_SEUL=/^(\s*)OFF(\s*)$/i;
/* 28/09/2026 : montant en fin de phrase au format anglais (« Vous économisez €3,59 ») : « 3,59 € » hors anglais */
var RX_EUR_FIN=/^(.*?\S\s)€\s?(\d{1,3}(?:[\s\u00a0\u202f.]\d{3})*(?:[.,]\d{1,2})?)(\s*)$/;
var MIN_BANDEAU={fr:function(a){return 'Commande minimum sur le site\u00a0: '+a;},en:function(a){return 'Minimum order on our site: '+a;},de:function(a){return 'Mindestbestellwert im Shop: '+a;},it:function(a){return 'Ordine minimo sul sito: '+a;}};
function trMontant(s){
  var m;
  if((m=s.match(RX_OFF))){var v=(m[2]||m[3]).trim();return m[1]+(L==='en'?'€'+v.replace(',','.'):v.replace('.',',')+'\u00a0€')+OFF_T[L]+m[4];}
  if((m=s.match(RX_PCT)))return m[1]+(L==='en'?m[2]+'%':m[2].replace('.',',')+'\u00a0%')+OFF_P[L]+m[3];
  if((m=s.match(RX_OFF_SEUL)))return L==='en'?null:m[1]+OFF_T[L].trim()+m[2];
  if(L!=='en'&&(m=s.match(RX_EUR)))return m[1]+m[2]+m[3]+'\u00a0€'+m[4];
  if(L!=='en'&&(m=s.match(RX_EUR_FIN)))return m[1]+m[2]+'\u00a0€'+m[3];
  return null;
}
function translateIn(root){
  if(!root||!root.querySelectorAll)return;
  var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null);
  var n,todo=[];
  while((n=w.nextNode())){if(n.nodeValue&&n.nodeValue.trim().length>1)todo.push(n);}
  todo.forEach(function(node){var v=node.nodeValue,x=L==='fr'?null:tr(v);if(x!==null)v=x;var y=trMontant(v);if(y!==null)v=y;if(v!==node.nodeValue)node.nodeValue=v;});
  if(L==='fr')return;
  root.querySelectorAll('[placeholder]').forEach(function(el){var v=tr(el.getAttribute('placeholder'));if(v!==null)el.setAttribute('placeholder',v);});
  root.querySelectorAll('[aria-label]').forEach(function(el){var v=tr(el.getAttribute('aria-label'));if(v!==null)el.setAttribute('aria-label',v);});
}
function moonRoots(){
  return [document.getElementById('moonbundle-cart-drawer')].concat(
    [].slice.call(document.querySelectorAll('[class*="moonbundle-pg-"],[id^="moonbundle-progressive-gift"],[class*="moonbundle-cart-"]'))
  ).filter(Boolean);
}

/* ---------- 4. Glissement tactile sur le carrousel "Souvent commande avec" ---------- */
function bindSwipe(){
  var wrap=document.querySelector('.moonbundle-cart-upsell-products-wrapper');
  if(!wrap||wrap.__nkSwipe)return;wrap.__nkSwipe=true;
  var x0=null,y0=null;
  wrap.addEventListener('touchstart',function(e){var t=e.touches[0];x0=t.clientX;y0=t.clientY;},{passive:true});
  wrap.addEventListener('touchend',function(e){
    if(x0===null)return;var t=e.changedTouches[0];var dx=t.clientX-x0,dy=t.clientY-y0;x0=null;
    if(Math.abs(dx)<40||Math.abs(dx)<Math.abs(dy))return;
    var btns=document.querySelectorAll('.moonbundle-cart-upsell-nav-btn');
    if(btns.length<2)return;
    var b=dx<0?btns[1]:btns[0];
    if(b&&!b.disabled)b.click();
  },{passive:true});
}

/* ---------- 5. La bulle de chat ne doit pas masquer le bouton du tiroir ---------- */
/* 2026-09-26 (clarté des fiches) : la bulle Klaviyo « -10 % » passe à 80 px du bas, au-dessus de la bulle cadeau
   Moon Bundles (elles se chevauchaient de 13 px) ; le prix au kilo n'est plus masqué sur les fiches (obligation
   d'affichage du prix à l'unité de mesure, voir snippets/nkosi-fiche-clarte-styles.liquid). */
function injectStyle(){
  if(document.getElementById('nk-moon-style'))return;
  var st=document.createElement('style');st.id='nk-moon-style';
  st.textContent='body.nk-moon-open shopify-chat,body.nk-moon-open #shopify-chat,body.nk-moon-open [id^="ShopifyChat"]{opacity:0!important;pointer-events:none!important;transition:opacity .2s ease}'+'body.template_product .product__inventory{display:none!important}'+'p.yv-product-detail-desc[data-nk-livraison-masquee]{display:none!important}'+'div[class*="kl-teaser-"]{margin-bottom:80px!important}'+/* 2026-09-27 S2 : frise, bouton bloqué sous 39 EUR et note du minimum stylés dans nkosi-marche-collage.css */'body.nk-sous-minimum shopify-accelerated-checkout-cart,body.nk-sous-minimum .additional-checkout-buttons,body.nk-sous-minimum #moonbundle-cart-drawer [class*="accelerated"]{display:none!important}';
  st.textContent+=BUY_SEL.split(',').map(function(s){return s+':not([data-nk-min-ok])';}).join(',')+'{display:none!important}';
  document.head.appendChild(st);
}
function syncChat(){
  var d=document.getElementById('moonbundle-cart-drawer');
  var pop=document.querySelector('.moonbundle-pg-popup,[class*="moonbundle-pg-atc-popup"]');
  var open=!!(d&&d.classList.contains('open'))||!!(pop&&pop.getBoundingClientRect().height>80);
  document.body.classList.toggle('nk-moon-open',open);
}

/* ---------- 6. Fiche produit : frise a la place des deux phrases de livraison ---------- */
var FRISE_HTML='<div class="nk-frise__msg" data-nk-frise-msg></div>'+
  '<div class="nk-frise__track"><div class="nk-frise__fill" data-nk-frise-fill></div>'+
  '<span class="nk-frise__dot nk-frise__dot--1" data-nk-frise-dot="1"></span>'+
  '<span class="nk-frise__dot nk-frise__dot--2" data-nk-frise-dot="2"></span></div>'+
  '<div class="nk-frise__labels"><span data-nk-frise-l1></span><span data-nk-frise-l2></span></div>'+
  '<span class="nk-frise__sub" data-nk-frise-sub></span>';
/* ---------- G28 : date de livraison estimee (preparation 1 a 3 jours ouvres + acheminement 2 a 3 jours ouvres, France metropolitaine) ---------- */
function nkEta(){
  var lg=(document.documentElement.lang||'fr').slice(0,2);
  function addBiz(d,n){var x=new Date(d);while(n>0){x.setDate(x.getDate()+1);var w=x.getDay();if(w!==0&&w!==6)n--;}return x;}
  var now=new Date(), a=addBiz(now,3), b=addBiz(now,6);
  var loc={fr:'fr-FR',en:'en-GB',de:'de-DE',it:'it-IT'}[lg]||'fr-FR';
  var f=function(d){return d.toLocaleDateString(loc,{weekday:'short',day:'numeric',month:'short'});};
  var lbl={fr:'Livraison estimée en France métropolitaine\u00a0: entre le %a et le %b',en:'Estimated delivery in mainland France: between %a and %b',de:'Voraussichtliche Lieferung in Frankreich: zwischen %a und %b',it:'Consegna stimata in Francia metropolitana: tra %a e %b'}[lg]||'';
  return lbl.replace('%a',f(a)).replace('%b',f(b));
}

/* vague 1 des maquettes : estimation courte du tiroir, mêmes jours ouvrés que nkEta (3 à 6) */
function nkEtaCourt(){
  var lg=(document.documentElement.lang||'fr').slice(0,2);
  function addBiz(d,n){var x=new Date(d);while(n>0){x.setDate(x.getDate()+1);var w=x.getDay();if(w!==0&&w!==6)n--;}return x;}
  var now=new Date(), a=addBiz(now,3), b=addBiz(now,6);
  var loc={fr:'fr-FR',en:'en-GB',de:'de-DE',it:'it-IT'}[lg]||'fr-FR';
  var f=function(d){return d.toLocaleDateString(loc,{weekday:'short',day:'numeric',month:'short'});};
  var lbl={fr:'Livraison estimée entre le %a et le %b',en:'Estimated delivery between %a and %b',de:'Voraussichtliche Lieferung zwischen %a und %b',it:'Consegna stimata tra %a e %b'}[lg]||'';
  return lbl.replace('%a',f(a)).replace('%b',f(b));
}

function pdpFrise(){
  if(document.body.className.indexOf('template_product')<0)return;
  /* 2026-09-27 (Marché Collage S2) : la frise de la fiche est rendue par le serveur (snippets/nkosi-mc-frise.liquid),
     plus de décalage à l'insertion. On complète seulement la date estimée si le serveur ne l'a pas écrite. */
  var srv=document.querySelector('[data-nk-frise-pdp]');
  if(srv){var e=srv.querySelector('.nk-frise__eta');if(e){try{setText(e,nkEta());}catch(x){}}return;}
  var ps=[].slice.call(document.querySelectorAll('p.yv-product-detail-desc'));
  /* 2026-09-08 : le filtre etait ecrit en francais, donc la frise et la date de livraison estimee
     n apparaissaient que sur les fiches FR. On reconnait desormais les paragraphes de livraison
     par les tarifs qu ils portent (6,90 relais et 9,90 domicile), ce qui marche dans les 4 langues. */
  var cibles=ps.filter(function(p){var t=p.textContent||'';return /(?:6|9)[.,]90\s*€/.test(t)&&/(?:39|69)\s*€/.test(t);});
  if(!cibles.length)return;
  var host=document.createElement('div');
  host.className='nk-frise nk-frise--pdp';
  host.setAttribute('data-nk-frise','');
  host.setAttribute('data-nk-frise-pdp','');
  host.innerHTML=FRISE_HTML;
  try{var eta=document.createElement('p');eta.className='nk-frise__eta';eta.textContent=nkEta();host.appendChild(eta);}catch(e){}
  cibles[0].parentNode.insertBefore(host,cibles[0]);
  cibles.forEach(function(p){p.setAttribute('data-nk-livraison-masquee','');p.style.display='none';});
  lastTotal=null;refreshFrise(true);
}

/* ---------- 6 bis. Commande minimum 39 EUR : bouton de paiement du tiroir et de la page panier (2026-09-16) ---------- */
/* vague 1 des maquettes (P3, 28/09/2026) : sous 39 EUR, le bouton dit ce qui manque (« Encore 7,53 € pour commander »,
   attribut data-nk-v1-libelle affiché par nkosi-marche-collage.css, section V1) et la note donne la règle une seule
   fois (locales nkosi_mc.v1.panier.regle et .encore, mêmes textes). data-nk-v1-sans-note : pas de note (barre mobile). */
var MIN_R={fr:'Commande minimum\u00a0: 39\u00a0€ d’articles.',en:'Minimum order: €39 of items.',de:'Mindestbestellwert: 39\u00a0€ Warenwert.',it:'Ordine minimo: 39\u00a0€ di articoli.'};
var MIN_B={fr:function(a){return 'Encore '+a+' pour commander';},en:function(a){return 'Add '+a+' more to check out';},de:function(a){return 'Noch '+a+' bis zur Bestellung';},it:function(a){return 'Ancora '+a+' per ordinare';}};
var CHECKOUT_SEL='button[name="checkout"],input[name="checkout"],#moonbundle-cart-drawer .moonbundle-cart-drawer-checkout,#moonbundle-cart-drawer button[class*="checkout"],#moonbundle-cart-drawer button[name="checkout"],#moonbundle-cart-drawer [class*="checkout-button"],#moonbundle-cart-drawer a[href*="/checkout"],form[action*="/cart"] [name="checkout"],.cart__checkout-button';
function minGuard(){
  if(lastTotal===null)return;
  var below=lastTotal<MINIMUM, btns=document.querySelectorAll(CHECKOUT_SEL), lib=below?MIN_B[L](euro(MINIMUM-lastTotal)):'';
  for(var i=0;i<btns.length;i++){
    var b=btns[i];
    setAttr(b,'data-nk-min-bloque',below);setAttr(b,'aria-disabled',below,'true');setAttr(b,'data-nk-v1-libelle',below,lib);
    if(b.hasAttribute('data-nk-v1-sans-note'))continue;
    var note=b.parentNode&&b.parentNode.querySelector('[data-nk-min-note]');
    if(below){
      if(!note){note=document.createElement('p');note.setAttribute('data-nk-min-note','');note.className='nk-min-note';b.parentNode.insertBefore(note,b);}
      setText(note,MIN_R[L]);
    }else if(note){note.parentNode.removeChild(note);}
  }
  document.body.classList.toggle('nk-sous-minimum',below);
  document.body.classList.add('nk-min-connu');
}
document.addEventListener('click',function(e){
  var el=e.target&&e.target.closest&&e.target.closest(CHECKOUT_SEL);
  if(el&&lastTotal!==null&&lastTotal<MINIMUM){e.preventDefault();e.stopImmediatePropagation();minGuard();}
},true);

/* ---------- 6 ter. Fiche produit : « Acheter maintenant » visible seulement si panier + selection >= 39 EUR (2026-09-16) ----------
   Le bouton ajoute la selection au panier puis envoie au paiement : sous 39 EUR la regle Checkout Blocks refuserait le paiement.
   Masque par defaut (style en ligne dans snippets/product-form.liquid), affiche ici via data-nk-min-ok.
   Selection = prix de l'offre Moon Bundles active de la section, sinon prix de la variante x quantite. Inconnu = masque.
   Le bouton de paiement express Shopify (shopify-payment-button) ignore le panier : seule la selection compte. */
var BUY_SEL='.nkosi-buy-now,form[action*="/cart/add"] .shopify-payment-button';
function montant(s){
  var m=String(s||'').replace(/[\s  ]/g,'').match(/\d[\d.,]*/);
  if(!m)return null;
  var t=m[0].replace(/[.,]$/,''),i=Math.max(t.lastIndexOf(','),t.lastIndexOf('.'));
  if(i>-1&&t.length-i-1===2)return Math.round(parseFloat(t.slice(0,i).replace(/[.,]/g,'')+'.'+t.slice(i+1))*100);
  var n=parseInt(t.replace(/[.,]/g,''),10);
  return isNaN(n)?null:n*100;
}
function totalSelection(btn){
  var form=btn.form||btn.closest('form');if(!form)return null; /* vague 1 des maquettes : bouton hors du formulaire (attribut form) */
  var sec=btn.closest('[id^="shopify-section"]');
  var act=sec&&sec.querySelector('.moonbundle-option-active .moonbundle-option-single-price');
  if(act){var v=montant(act.textContent);if(v!==null)return v;}
  var idIn=form.querySelector('[name="id"]'),qIn=form.querySelector('[name="quantity"]');
  var q=Math.max(1,parseInt(qIn&&qIn.value,10)||1);
  var p=window.ShopifyAnalytics&&ShopifyAnalytics.meta&&ShopifyAnalytics.meta.product;
  if(p&&p.variants&&idIn){for(var i=0;i<p.variants.length;i++){if(String(p.variants[i].id)===String(idIn.value))return p.variants[i].price*q;}}
  return null;
}
function buyNowGuard(){
  var btns=document.querySelectorAll(BUY_SEL);
  for(var i=0;i<btns.length;i++){
    var b=btns[i],sel=totalSelection(b);
    var base=b.classList.contains('shopify-payment-button')?0:lastTotal;
    var ok=sel!==null&&base!==null&&(base+sel)>=MINIMUM;
    setAttr(b,'data-nk-min-ok',ok);
  }
}
document.addEventListener('click',function(e){
  if(!e.target||!e.target.closest)return;
  var b=e.target.closest(BUY_SEL);
  if(b&&!b.hasAttribute('data-nk-min-ok')){e.preventDefault();e.stopImmediatePropagation();buyNowGuard();return;}
  if(e.target.closest('.moonbundle-box'))[60,400].forEach(function(ms){setTimeout(buyNowGuard,ms);});
},true);
document.addEventListener('change',function(e){if(e.target&&e.target.closest&&e.target.closest('form[action*="/cart/add"]'))setTimeout(buyNowGuard,60);},true);

/* ---------- 7. Accessibilite : alt manquant sur les vignettes du menu ---------- */
function fixAlts(){
  var imgs=document.querySelectorAll('img:not([alt])');
  for(var i=0;i<imgs.length;i++){
    var im=imgs[i];
    var a=im.closest?im.closest('a'):null;
    var t=a?a.textContent.replace(/\s+/g,' ').trim():'';
    im.setAttribute('alt', (t && t.length<80) ? t : '');
  }
}

/* ---------- Orchestration ---------- */
function tick(){ injectStyle(); syncChat(); fixAlts(); pdpFrise(); refreshFrise(false); minGuard(); buyNowGuard(); bindSwipe(); moonRoots().forEach(translateIn); }
function boot(){
  tick();
  ['moonbundle-cart-updated','cart:updated','cart:refresh'].forEach(function(ev){
    document.addEventListener(ev,function(){lastTotal=null;refreshFrise(true);setTimeout(tick,250);});
  });
  document.addEventListener('nkosi:cart:added',function(){lastTotal=null;refreshFrise(true);setTimeout(tick,250);});
  /* 2026-09-18 : Moon Bundles émet moonbundle-cart-updated sur window (tiroir : quantité, suppression, code,
     vente additionnelle), jamais sur document. L'écoute sur document ne le recevait pas ; seule la relecture
     continue de /cart.js masquait ce défaut. Filet de sécurité : toute écriture panier vue par Resource Timing. */
  window.addEventListener('moonbundle-cart-updated',function(){lastTotal=null;refreshFrise(true);setTimeout(tick,250);});
  try{new PerformanceObserver(function(l){
    if(l.getEntries().some(function(e){return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(e.name);})){lastTotal=null;refreshFrise(true);setTimeout(tick,250);}
  }).observe({type:'resource'});}catch(e){}
  var mo=new MutationObserver(function(){ if(window.__nkTickT)clearTimeout(window.__nkTickT); window.__nkTickT=setTimeout(tick,120); });
  mo.observe(document.body,{childList:true,subtree:true});
  [300,900,2000,4000].forEach(function(t){setTimeout(tick,t);});
  if(document.querySelector(BUY_SEL))setInterval(buyNowGuard,1500);
  /* 2026-09-18 : le total n'est plus relu en continu ; on le relit quand l'onglet redevient visible
     ou quand la page revient du cache (panier modifié dans un autre onglet). */
  document.addEventListener('visibilitychange',function(){if(document.visibilityState==='visible'){lastTotal=null;refreshFrise(true);}});
  window.addEventListener('pageshow',function(e){if(e.persisted){lastTotal=null;refreshFrise(true);}});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
